import { isFunction, remove } from 'lodash-es'

import { ProductAPI } from 'src/api'

export default {
  state: {
    productsList: null,
    products: {},
  },
  mutations: {
    SET_PRODUCTS_LIST(state, payload) {
      state.productsList = payload
    },
    SET_PRODUCTS(state, payload) {
      state.products = payload
    },
    ADD_PRODUCT(state, { productCategoryId = null, body = {} }) {
      const categories = { ...state.categories }
      const products = { ...state.products }
      const category = categories[productCategoryId]
      if (category) {
        products[body.id] = {
          categoryType: 'product',
          category: productCategoryId,
          subproducts: [],
          ...body,
        }
        category.products.push(body.id)
        state.categories = categories
        state.products = products
      }
    },
    REMOVE_PRODUCT(state, { id }) {
      const categories = { ...state.categories }
      const product = state.products[id]
      remove(categories[product.category].products, (item) => item === id)
      state.categories = categories
    },
    UPDATE_PRODUCT(state, { id, payload = {} }) {
      const product = state.products[id]
      if (product) {
        if (isFunction(payload)) {
          state.products[id] = payload(product)
        } else {
          state.products[id] = {
            ...product,
            ...payload,
          }
        }
      }
    },
  },
  actions: {
    async createProduct(_, body) {
      const { name, description, productCategoryId, strategy } = body

      return ProductAPI.create({
        name,
        description,
        strategy,
        productCategoryId,
      })
    },
    updateProduct({ commit }, { id, body }) {
      if (!id) {
        return
      }

      return ProductAPI.update({ ...body, productId: id }).then((data) => {
        if (data) {
          commit('UPDATE_PRODUCT', {
            id,
            payload: {
              title: body.name,
              ...body,
            },
          })
        } else {
          /* TODO: RAISE ERROR MODAL */
        }
      })
    },
  },
  getters: {
    getProduct: (state) => (id) => (state.products ? state.products[id] : {}),
  },
}
